
import Vue from 'vue'
import CreditNoteTransformer from '@/transformers/taxReceipt/creditNote'

export default (taxReceiptId) =>
  Vue.$http.get(`taxreceipt/taxreceipt/${taxReceiptId}/creditnotes/`)
    .then(response => CreditNoteTransformer.fetchCollection(response.data))



// WEBPACK FOOTER //
// ./src/services/taxReceipt/fetchCreditNotes.js